export default "__VITE_ASSET__DgiOY9Hn__"